import React from "react";
import {Link} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import tireFinderQuote from '../../../shared/assets/icons/icon-tire-finder-quote.svg';
import arrowLeftUnavailable from "../../../shared/assets/icons/arrow-left-unavailable.svg";

const Header = ({title, page, viewQuote}) => {



    return (
        <header style={{width: '100%'}}>
            <Grid container spacing={1} alignItems={'flex-end'}>
                <Grid item xs={6}>
                    <div>
                        <Link to={page} style={{textDecoration: 'none'}} className={'stat-button-link'}
                              data-dtm="breadcrumbs">
                            <img src={arrowLeftUnavailable} alt={title}/></Link>
                    </div>
                </Grid>
                <Grid item xs={6}>
                    {viewQuote && <div className={'viewQuote'}>
                        <Link to='/cart' className={'stat-icon-link'} data-dtm="breadcrumbs"
                              style={{display:"flex", alignItems: "flex-end"}}>
                            <img src={tireFinderQuote} alt={'Quote Icon'}/>{'View Quote'}</Link>
                    </div>}
                </Grid>
            </Grid>
        </header>
    )
};

Header.defaultProps = {
    title: 'Back',
};

export default Header
